export const PlayStore = {
    BRASIL: "https://play.google.com/store/apps/details?id=com.bayer.cs.universomedicoapp",
    MEXICO: "https://play.google.com/store/apps/details?id=com.bayer.cs.bescience",
    CONOSUR: "https://play.google.com/store/apps/details?id=com.bayer.ph.universomedicoconosur",
    PACA: "https://play.google.com/store/apps/details?id=com.bayer.ph.universomedicopaca"
};


// WEBPACK FOOTER //
// ./src/helpers/enums/PlayStoreEnum.js